import { useState, useEffect } from 'react';

const API = import.meta.env.VITE_API_URL || '/api';
const EMPTY = { code: '', type: 'percent', value: '', min_order: '', max_uses: '', expires_at: '', active: 1 };

export default function Discounts() {
  const [coupons, setCoupons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState(EMPTY);
  const [editing, setEditing] = useState(null);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');
  const token = localStorage.getItem('admin_token');

  const fetchCoupons = () => {
    setLoading(true);
    fetch(`${API}/get-coupons.php`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json()).then(d => setCoupons(d.coupons || []))
      .catch(() => setCoupons([])).finally(() => setLoading(false));
  };

  useEffect(() => { fetchCoupons(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault(); setSaving(true); setMsg('');
    const endpoint = editing ? 'update-coupon.php' : 'create-coupon.php';
    const r = await fetch(`${API}/${endpoint}`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({ ...form, id: editing }),
    }).then(r => r.json()).catch(() => ({ success: false }));
    setSaving(false);
    if (r.success) { setMsg('✅ Coupon saved!'); setForm(EMPTY); setEditing(null); fetchCoupons(); }
    else setMsg(`❌ ${r.message || 'Error saving coupon'}`);
  };

  const toggleActive = async (id, current) => {
    await fetch(`${API}/update-coupon.php`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({ id, active: current ? 0 : 1 }),
    });
    fetchCoupons();
  };

  const handleDelete = async (id) => {
    if (!confirm('Delete this coupon?')) return;
    await fetch(`${API}/delete-coupon.php`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({ id }),
    });
    fetchCoupons();
  };

  const inp = (label, name, type='text', placeholder='') => (
    <div style={{ marginBottom: '1rem' }}>
      <label style={{ display: 'block', fontFamily: "'Cinzel',serif", fontSize: '.62rem', letterSpacing: '.18em', textTransform: 'uppercase', color: 'rgba(255,184,0,.6)', marginBottom: '.4rem' }}>{label}</label>
      <input type={type} value={form[name]} onChange={e => setForm({ ...form, [name]: e.target.value })} placeholder={placeholder}
        style={{ width: '100%', padding: '.75rem .9rem', background: 'rgba(255,255,255,.06)', border: '1px solid rgba(255,184,0,.22)', borderRadius: 6, color: '#FFE082', fontFamily: "'Crimson Pro',serif", fontSize: '.9rem', outline: 'none', boxSizing: 'border-box' }} />
    </div>
  );

  return (
    <div>
      <h1 style={{ fontFamily: "'Cinzel Decorative',serif", fontSize: '1.5rem', background: 'linear-gradient(135deg,#FFE082,#FF6B00)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', marginBottom: '1.8rem' }}>🏷️ Discounts & Coupons</h1>

      {/* Form */}
      <div style={{ background: 'linear-gradient(135deg,rgba(20,4,0,.98),rgba(26,10,46,.98))', border: '1px solid rgba(255,184,0,.25)', borderRadius: 10, padding: '2rem', marginBottom: '2rem' }}>
        <h3 style={{ fontFamily: "'Cinzel',serif", fontSize: '.78rem', letterSpacing: '.2em', textTransform: 'uppercase', color: '#FFB800', marginBottom: '1.5rem' }}>{editing ? '✏️ Edit Coupon' : '➕ New Coupon'}</h3>
        {msg && <div style={{ padding: '.75rem 1rem', borderRadius: 6, marginBottom: '1rem', background: msg.startsWith('✅') ? 'rgba(76,175,80,.15)' : 'rgba(192,57,43,.15)', border: `1px solid ${msg.startsWith('✅') ? 'rgba(76,175,80,.3)' : 'rgba(192,57,43,.3)'}`, fontFamily: "'Cinzel',serif", fontSize: '.75rem', color: msg.startsWith('✅') ? '#4CAF50' : '#ff6b6b' }}>{msg}</div>}
        <form onSubmit={handleSubmit}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(200px,1fr))', gap: '0 1.5rem' }}>
            {inp('Coupon Code *', 'code', 'text', 'DIWALI25')}
            <div style={{ marginBottom: '1rem' }}>
              <label style={{ display: 'block', fontFamily: "'Cinzel',serif", fontSize: '.62rem', letterSpacing: '.18em', textTransform: 'uppercase', color: 'rgba(255,184,0,.6)', marginBottom: '.4rem' }}>Discount Type</label>
              <select value={form.type} onChange={e => setForm({ ...form, type: e.target.value })}
                style={{ width: '100%', padding: '.75rem .9rem', background: 'rgba(13,5,0,.95)', border: '1px solid rgba(255,184,0,.22)', borderRadius: 6, color: '#FFE082', fontFamily: "'Cinzel',serif", fontSize: '.72rem', letterSpacing: '.08em', outline: 'none', boxSizing: 'border-box' }}>
                <option value="percent">Percentage (%)</option>
                <option value="fixed">Fixed Amount (₹)</option>
              </select>
            </div>
            {inp(`Discount Value (${form.type === 'percent' ? '%' : '₹'}) *`, 'value', 'number', form.type === 'percent' ? '20' : '100')}
            {inp('Minimum Order (₹)', 'min_order', 'number', '500')}
            {inp('Max Uses', 'max_uses', 'number', '100')}
            {inp('Expires At', 'expires_at', 'date')}
          </div>
          <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', marginTop: '.5rem' }}>
            <button type="submit" disabled={saving}
              style={{ padding: '.9rem 2rem', background: 'linear-gradient(135deg,#FF6B00,#FFB800)', border: 'none', borderRadius: 6, color: '#0D0500', fontFamily: "'Cinzel',serif", fontSize: '.78rem', fontWeight: 700, letterSpacing: '.15em', textTransform: 'uppercase', cursor: saving ? 'not-allowed' : 'pointer' }}>
              {saving ? '🌀 Saving…' : '🏷️ Save Coupon'}
            </button>
            {editing && <button type="button" onClick={() => { setForm(EMPTY); setEditing(null); setMsg(''); }} style={{ padding: '.9rem 1.5rem', background: 'transparent', border: '1px solid rgba(255,184,0,.25)', borderRadius: 6, color: 'rgba(255,224,130,.6)', fontFamily: "'Cinzel',serif", fontSize: '.72rem', letterSpacing: '.12em', textTransform: 'uppercase', cursor: 'pointer' }}>Cancel</button>}
          </div>
        </form>
      </div>

      {/* Coupons List */}
      <div style={{ background: 'linear-gradient(135deg,rgba(20,4,0,.95),rgba(26,10,46,.95))', border: '1px solid rgba(255,184,0,.18)', borderRadius: 10, overflow: 'auto' }}>
        {loading ? <div style={{ padding: '2rem', textAlign: 'center', color: 'rgba(255,224,130,.4)', fontFamily: "'Cinzel',serif" }}>🌀 Loading…</div> : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '1px solid rgba(255,184,0,.1)' }}>
                {['Code', 'Type', 'Value', 'Min Order', 'Used / Max', 'Expires', 'Status', 'Actions'].map(h => (
                  <th key={h} style={{ padding: '.7rem 1rem', textAlign: 'left', fontFamily: "'Cinzel',serif", fontSize: '.6rem', letterSpacing: '.15em', textTransform: 'uppercase', color: 'rgba(255,184,0,.5)', fontWeight: 600 }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {coupons.length === 0 ? (
                <tr><td colSpan={8} style={{ padding: '2rem', textAlign: 'center', color: 'rgba(255,224,130,.4)', fontFamily: "'Cinzel',serif", fontSize: '.78rem' }}>No coupons yet 🏷️</td></tr>
              ) : coupons.map(c => (
                <tr key={c.id} style={{ borderBottom: '1px solid rgba(255,184,0,.06)' }}>
                  <td style={{ padding: '.75rem 1rem' }}><span style={{ fontFamily: "'Cinzel',serif", fontSize: '.82rem', color: '#FFB800', fontWeight: 700, letterSpacing: '.1em' }}>{c.code}</span></td>
                  <td style={{ padding: '.75rem 1rem', fontFamily: "'Cinzel',serif", fontSize: '.7rem', color: 'rgba(255,224,130,.6)', textTransform: 'uppercase', letterSpacing: '.1em' }}>{c.type}</td>
                  <td style={{ padding: '.75rem 1rem', fontFamily: "'Cinzel',serif", fontSize: '.82rem', color: '#4CAF50', fontWeight: 700 }}>{c.type === 'percent' ? `${c.value}%` : `₹${c.value}`}</td>
                  <td style={{ padding: '.75rem 1rem', fontFamily: "'Crimson Pro',serif", fontSize: '.85rem', color: 'rgba(255,224,130,.6)' }}>{c.min_order ? `₹${c.min_order}` : '—'}</td>
                  <td style={{ padding: '.75rem 1rem', fontFamily: "'Crimson Pro',serif", fontSize: '.85rem', color: 'rgba(255,224,130,.6)' }}>{c.used_count || 0} / {c.max_uses || '∞'}</td>
                  <td style={{ padding: '.75rem 1rem', fontFamily: "'Crimson Pro',serif", fontSize: '.78rem', color: 'rgba(255,224,130,.4)' }}>{c.expires_at ? new Date(c.expires_at).toLocaleDateString('en-IN') : '—'}</td>
                  <td style={{ padding: '.75rem 1rem' }}>
                    <span onClick={() => toggleActive(c.id, c.active)} style={{ cursor: 'pointer', background: c.active ? 'rgba(76,175,80,.15)' : 'rgba(192,57,43,.15)', color: c.active ? '#4CAF50' : '#ff6b6b', border: `1px solid ${c.active ? 'rgba(76,175,80,.3)' : 'rgba(192,57,43,.3)'}`, borderRadius: 20, padding: '.2rem .7rem', fontFamily: "'Cinzel',serif", fontSize: '.6rem', letterSpacing: '.1em', textTransform: 'uppercase' }}>
                      {c.active ? '● Active' : '○ Inactive'}
                    </span>
                  </td>
                  <td style={{ padding: '.75rem 1rem' }}>
                    <div style={{ display: 'flex', gap: '.4rem' }}>
                      <button onClick={() => { setEditing(c.id); setForm({ code: c.code, type: c.type, value: c.value, min_order: c.min_order || '', max_uses: c.max_uses || '', expires_at: c.expires_at ? c.expires_at.slice(0, 10) : '', active: c.active }); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
                        style={{ padding: '.3rem .7rem', background: 'rgba(255,184,0,.12)', border: '1px solid rgba(255,184,0,.25)', borderRadius: 4, color: '#FFE082', cursor: 'pointer', fontFamily: "'Cinzel',serif", fontSize: '.6rem', letterSpacing: '.08em' }}>Edit</button>
                      <button onClick={() => handleDelete(c.id)}
                        style={{ padding: '.3rem .7rem', background: 'rgba(192,57,43,.12)', border: '1px solid rgba(192,57,43,.25)', borderRadius: 4, color: '#ff6b6b', cursor: 'pointer', fontFamily: "'Cinzel',serif", fontSize: '.6rem', letterSpacing: '.08em' }}>Del</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
